import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, Params }   from '@angular/router';
import { AnalysisService } from './analysis.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { AutoCompleteService } from '../shared/auto-complete.service';
import {IMyOptions, IMyDateModel} from 'ngx-mydatepicker';
import * as moment from 'moment/moment';
import { Request } from '../entity/request';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Observable } from 'rxjs/Observable';
import { BlobService } from '../shared/blob.service';
import {environment} from '../../environments/environment';
import {AuthenticationService} from '../security/authentication.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'analysis',
  templateUrl: './analysis.component.html'
})
export class AnalysisComponent {

  private filters;
  private statuses;
  private pager: {};
  private requests: Request[];
  public allRequests: Request[];

  private currentPage: number;

  public showMore: boolean[];
  public loading: boolean;

  public status: string;
  public search: string;

  public showFilters: boolean;
  public loadingMore: boolean;

  public typeaheadLoading: boolean;
  public dataSource: Observable<any>;
  public lastComment: {};
  public allComments;
  public orderedBy: {};

  constructor(private route: ActivatedRoute,
              private analysisService: AnalysisService,
              private spinnerService: SpinnerService,
              private autoCompleteService: AutoCompleteService,
              private blobService: BlobService,
              private authenticationService: AuthenticationService) {

    this.filters = {dateStart:null, dateEnd:null, request:null, sample:null, du:null, product:null, selectedStatus:"VALIDE"};
    this.statuses = [
        {code : "", label : ""},
        {code : "ENATTENTE", label : "En attente"},
        {code : "ENCOURS", label : "En cours"},
        {code : "VALIDE", label : "Validées"},
        {code : "PARTVALIDE", label : "Partiellement Validées"},
        //{code : "ANNULE", label : "Annulées"},
        //{code : "REJET", label : "Rejetées"}
      ];

    this.allRequests = new Array();
    this.currentPage = 1;
    this.showMore = new Array();
    this.showFilters = true;
    this.loading = false;
    this.loadingMore = false;
    this.search = "";
    this.lastComment = {};
    this.allComments = new Array();
    this.orderedBy = {};

  }

  private datePickerOptions: IMyOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    dayLabels: {su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam'},
    monthLabels: { 1: 'Janvier', 2: 'Fevrier', 3: 'Mars', 4: 'Avril', 5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Aout', 9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Decembre' },
    showTodayBtn: false,
    sunHighlight: false,
    alignSelectorRight: false
  };

  ngOnInit(): void {
      this.currentPage = 1;
      this.allRequests = new Array();
      this.onScroll ();
  }

  filter(event): void {
    this.currentPage = 1;
    this.allRequests = new Array();
    this.loadingMore = false;
    this.getResults();
  }

  private parseResultsResponse(response: any): void {
    this.pager = response.pager;

    const pager = response.pager;
    // merge last comment data to keep track of the previous data we had
    this.lastComment = Object.assign({}, this.lastComment, response.lastComment);
    this.allComments = Object.assign({}, this.allComments, response.allComments);
    this.orderedBy = Object.assign({}, this.orderedBy, response.orderedBy);

    this.status = "VALIDE";
    const valide_requests = response.requests['VALIDE'];
    if (this.allRequests['VALIDE'] == undefined) {
        this.allRequests['VALIDE'] = new Array();
    }
    if (valide_requests != undefined) {
        this.allRequests['VALIDE'] = this.allRequests['VALIDE'].concat(valide_requests);
    }


    for (const status in pager.counts) {
      if (this.allRequests[status]) {
        const count = this.allRequests[status].length;
        this.showMore[status] = count < pager.counts[status];
      } else {
        this.showMore[status] = false;
      }
    }



  }

  public getResults(): void {
    let criteria = {
        start_date: this.filters.dateStart,
        end_date: this.filters.dateEnd,
        request: this.filters.request,
        sample: this.filters.sample,
        du: this.filters.du,
        selectedStatus: this.filters.selectedStatus,
        package: this.filters.package,
        subscription: this.filters.subscription,
        page: this.currentPage
    };
    if(!this.loadingMore){
      this.spinnerService.start("Chargement des résultats");
    }
    this.loading = true;
    this.analysisService.getRequests(criteria)
    .then(
      function(response: any){
        this.parseResultsResponse(response);
        this.spinnerService.stop();
        this.loading = false;
        this.loadingMore = false;
      }.bind(this),
      function(){
        this.spinnerService.stop();
        this.loading = false;
        this.loadingMore = false;
      }.bind(this)
    );
  }

    public clearFilters(): void {
        this.filters = {dateStart:null, dateEnd:null, request:null, sample:null, du:null, product:null, selectedStatus:"VALIDE"};

        let criteria = {
            start_date: null,
            end_date: null,
            request: null,
            sample: null,
            du: null,
            selectedStatus: "VALIDE",
            package: null,
            subscription: null,
            page: 1
        };
        if(!this.loadingMore){
            this.spinnerService.start("Chargement des résultats");
        }
        this.loading = true;
        this.analysisService.getRequests(criteria)
            .then(
                function(response: any){
                    this.parseResultsResponse(response);
                    this.spinnerService.stop();
                    this.loading = false;
                    this.loadingMore = false;
                }.bind(this),
                function(){
                    this.spinnerService.stop();
                    this.loading = false;
                    this.loadingMore = false;
                }.bind(this)
            );
    }

  public getResultCSV(requestNumber): void {
    this.loading = true;
    this.spinnerService.start('Chargement de l\'export');
    this.analysisService.getRequestCsv(requestNumber)
      .then(
        function(response: any){
          const blob = new Blob([ response.csv ], {type : 'text/csv;charset=utf-8;'});
          this.blobService.save(blob, 'export_' + requestNumber + '.csv');
          this.spinnerService.stop();
          this.loading = false;
        }.bind(this),
        function(){
          this.spinnerService.stop();
        }.bind(this)
      );
  }

    public getResultPdf(requestNumber): void {
        this.loading = true;
        this.spinnerService.start('Chargement du rapport pdf');
        this.analysisService.getRequestPdf(requestNumber).finally(() => {
        })
            .subscribe((doc: Blob) => {
                FileSaver.saveAs(doc, requestNumber + '.pdf');
                this.spinnerService.stop();
            })
        ;
    }

   public downloadOrderForm(orderNumber): void {
        this.loading = true;
        this.spinnerService.start('Chargement du bon de commande');
        this.analysisService.downloadOrderForm(orderNumber).finally(() => {
        })
            .subscribe((doc: Blob) => {
                FileSaver.saveAs(doc, orderNumber + '.pdf');
                this.spinnerService.stop();
            })
        ;
  }

    public deleteRequest(requestNumber): void {
        this.loading = true;
        this.spinnerService.start('Chargement');
        this.analysisService.deleteRequest(requestNumber)
            .then(
                function(response: any){
                    this.spinnerService.stop();
                    this.loading = false;
                }.bind(this),
                function(){
                    this.spinnerService.stop();
                }.bind(this)
            );
    }


  public toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  public changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  public onScroll () {
    this.loadingMore = true;
    this.getResults();
    this.currentPage++;
  }

    public displayOrderButonOnlyForClients(): boolean {
        let currentUserThirdParty = this.authenticationService.getCurrentUser().thirdParty;
        console.log(currentUserThirdParty.type.code);
        return !(environment.clientsNotAllowedToOrderAnalysis.indexOf(currentUserThirdParty.type.code) >= 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/analysis/analysis.component.ts